module.exports = __webpack_public_path__ + "static/04-defd3a690d9586df97bba28b08f7ae5b.jpg";